import React from 'react';

interface TemplateConfig {
  anaRenk: string;
  aksanRenk: string;
  font: string;
  fontBoyutu: number;
}

interface ParagraphBlockRendererProps {
  block: { settings: Record<string, any> };
  config: TemplateConfig;
}

const ParagraphBlockRenderer: React.FC<ParagraphBlockRendererProps> = ({ block, config }) => {
  const s = block.settings;
  const text = String(s.text ?? '');
  const fontSize =
    typeof s.fontSize === 'number' && Number.isFinite(s.fontSize)
      ? s.fontSize
      : config.fontBoyutu;
  const color = typeof s.color === 'string' ? s.color : '#1a1a1a';
  const alignRaw = s.align;
  const align =
    alignRaw === 'center' || alignRaw === 'right' || alignRaw === 'left' ? alignRaw : 'left';

  return (
    <div
      style={{
        fontFamily: config.font,
        fontSize,
        fontWeight: 400,
        color,
        textAlign: align,
        lineHeight: 1.55,
        whiteSpace: 'pre-wrap',
        margin: 0,
        padding: 0,
      }}
    >
      {text}
    </div>
  );
};

export default ParagraphBlockRenderer;
